
export const content = {
  en: {
    seo: {
      title: "StudioCeiling - Professional Ceiling Design & Installation",
      description: "StudioCeiling offers top-notch ceiling design and installation services. Transforming spaces with innovative and beautiful ceiling solutions.",
      keywords: ["ceiling design", "ceiling installation", "interior design", "Tbilisi", "Georgia", "modern ceilings"]
    },
    header: {
      about: "About Us",
      examples: "Our Work Examples",
      contact: "Contact",
      toggleLanguage: "Geo/Eng",
      toggleTheme: "Day/Night",
    },
    about: {
      title: "About Us",
      paragraph1:
        "Welcome to StudioCeiling! We providing top-notch ceiling design and installation services. Our team of experienced professionals is passionate about transforming your spaces with innovative and beautiful ceiling solutions.",
      paragraph2:
        "At StudioCeiling, we believe that the ceiling is a crucial element in interior design, often overlooked. Our mission is to bring attention to this important aspect of your home or office, creating stunning and functional designs that elevate your space.",
      paragraph3:
        "Whether you are looking for a modern, minimalist design or a more traditional, ornate look, we have the expertise and creativity to bring your vision to life. We work closely with our clients to understand their needs and preferences, ensuring a personalized experience and exceptional results.",
      paragraph4:
        "Thank you for considering StudioCeiling for your ceiling design needs. We look forward to working with you and making your ceilings a masterpiece.",
    },
    examples: {
      title: "Our Work Examples",
    },
    contact: {
      title: "Contact Us",
      location: "Location",
      streetLabel: "Street:",
      street: "D. Bakradze",
      cityLabel: "City:",
      city: "Tbilisi",
      countryLabel: "Country:",
      country: "Georgia",
      getInTouch: "Get in Touch",
      email: "info@studioceiling.ge",
      phone: "+995 598028028",
      emailLabel: "Email:",
      phoneLabel: "Phone:",
    },
  },
  ka: {
    seo: {
      title: "StudioCeiling - ჭერის პროფესიონალური დიზაინი და მონტაჟი",
      description: "StudioCeiling გთავაზობთ ჭერის უმაღლესი დონის დიზაინსა და სამონტაჟო მომსახურებას. გარდაქმენით თქვენი სივრცე ინოვაციური და ლამაზი ჭერის გადაწყვეტილებებით.",
      keywords: ["ჭერის დიზაინი", "ჭერის მონტაჟი", "ინტერიერის დიზაინი", "თბილისი", "საქართველო", "თანამედროვე ჭერი"]
    },
    header: {
      about: "ჩვენს შესახებ",
      examples: "ნამუშევრები",
      contact: "კონტაქტი",
      toggleLanguage: "ინგლისური",
      toggleLanguageMobile: "ქართ/ინგ",
      toggleTheme: "დღე/ღამე",
    },
    about: {
      title: "ჩვენს შესახებ",
      paragraph1:
        "კეთილი იყოს თქვენი მობრძანება StudioCeiling-ში! ჩვენ გთავაზობთ მაღალი დონის ჭერის დიზაინს და მონტაჟის მომსახურებას. ჩვენი გამოცდილი პროფესიონალების გუნდი გატაცებულია თქვენი სივრცეების ტრანსფორმაციით ინოვაციური და ლამაზი ჭერის გადაწყვეტილებებით.",
      paragraph2:
        "StudioCeiling-ში ჩვენ გვჯერა, რომ ჭერი ინტერიერის დიზაინის მნიშვნელოვანი ელემენტია, რომელიც ხშირად იგნორირებულია. ჩვენი მისიაა ყურადღება მივაქციოთ თქვენი სახლის ან ოფისის ამ მნიშვნელოვან ასპექტს, შევქმნათ განსაცვიფრებელი და ფუნქციონალური დიზაინები, რომლებიც ამაღლებს თქვენს სივრცეს.",
      paragraph3:
        "თქვენ ეძებთ თანამედროვე, მინიმალისტურ დიზაინს ან უფრო ტრადიციულ, ორნამენტულ იერს, ჩვენ გვაქვს ექსპერტიზა და კრეატიულობა, რათა თქვენი ხედვა რეალობად აქციოთ. ჩვენ მჭიდროდ ვთანამშრომლობთ ჩვენს კლიენტებთან მათი საჭიროებებისა და პრეფერენციების გასაგებად, უზრუნველყოფს პერსონალურ გამოცდილებას და განსაკუთრებულ შედეგებს.",
      paragraph4:
        "გმადლობთ, რომ განიხილავთ StudioCeiling-ს თქვენი ჭერის დიზაინის საჭიროებისთვის. ჩვენ მოუთმენლად ველით თქვენთან მუშაობას და თქვენი ჭერის შედევრად გადაქცევას.",
    },
    examples: {
      title: "ნამუშევრები",
    },
    contact: {
      title: "დაგვიკავშირდით",
      location: "მისამართი",
      streetLabel: "ქუჩა:",
      street: "დ. ბაქრაძე",
      cityLabel: "ქალაქი:",
      city: "თბილისი",
      countryLabel: "ქვეყანა:",
      country: "საქართველო",
      getInTouch: "საკონტაქტო",
      email: "info@studioceiling.ge",
      phone: "+995 598028028",
      emailLabel: "ელ.ფოსტა:",
      phoneLabel: "ტელეფონი:",
    },
  },
};
